import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import { useAuthStore } from '@/stores/useAuthStore';
import type { WorkerProfile } from '@/types/worker';

export const WORKER_KEYS = {
    all: ['worker'] as const,
    profile: () => [...WORKER_KEYS.all, 'profile'] as const,
    feed: (params?: Record<string, string>) => [...WORKER_KEYS.all, 'feed', params] as const,
    job: (uuid: string) => [...WORKER_KEYS.all, 'job', uuid] as const,
    assignments: (params?: Record<string, string>) => [...WORKER_KEYS.all, 'assignments', params] as const,
    assignment: (uuid: string) => [...WORKER_KEYS.all, 'assignment', uuid] as const,
    transactions: () => [...WORKER_KEYS.all, 'transactions'] as const,
};

export const useWorkerProfile = () => {
    const isLogged = useAuthStore((s) => s.isLogged);

    return useQuery({
        queryKey: WORKER_KEYS.profile(),
        enabled: isLogged,
        queryFn: async (): Promise<WorkerProfile> => {
            const { data } = await api.get(API_ROUTES.workerMe);
            return data;
        },
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
